var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expert-panel-session"},[_c('Breadcrumbs',{attrs:{"items":_vm.breadcrumbs}}),_c('main',[(_vm.ready)?_c('ExpertWorkSession',{attrs:{"type":_vm.type,"eid":_vm.eventId,"event-path":_vm.eventPath,"session":_vm.workSession,"user":_vm.user}}):_c('Wait')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }